var _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6719 11.557H25.3359C24.4611 11.557 23.752 10.9099 23.752 10.1117V4.33008",
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49603 11.557V7.22087C9.49603 5.62433 10.9144 4.33008 12.664 4.33008H24.0244C24.8646 4.33008 25.6702 4.63491 26.2642 5.17708L30.7437 9.26465C31.3379 9.80665 31.6719 10.5418 31.6719 11.3084V27.4564C31.6719 29.0529 30.2536 30.3472 28.504 30.3472H12.664C10.9144 30.3472 9.49603 29.0529 9.49603 27.4564V26.011",
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6134 17.2832L11.6534 20.8967L9.2774 18.7286",
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.74402,
    y: 11.5566,
    width: 15.8399,
    height: 14.4539,
    rx: 5.125,
    stroke: "#006AFF",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/fileicon.03bfdb1296837e21a52f610aaf65e2dd.svg";
export { ForwardRef as ReactComponent };